import { useRuntimeConfig } from '#imports'
import { type Ref, toValue, watchEffect } from 'vue'

import { useSignifyd } from '@backmarket/nuxt-layer-fraud/useSignifyd'
import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

export const FraudDetectionStep = {
  IDLE: 'IDLE',
  CHECKOUT_IN_PROGRESS: 'CHECKOUT_IN_PROGRESS',
  CHECKOUT_ENDED: 'CHECKOUT_ENDED',
} as const

export type FraudDetectionStep = UnionOfPropertyTypes<typeof FraudDetectionStep>

type UseFraudDetectionScriptsOptions = {
  /**
   *
   */
  currentStep: Ref<FraudDetectionStep>
}

/**
 * Loads the Signifyd script for checkout and resets it once checkout is complete.
 */
export const useFraudDetectionScripts = ({
  currentStep,
}: UseFraudDetectionScriptsOptions) => {
  if (import.meta.server) {
    return
  }

  if (useRuntimeConfig().public.payment.KILL_FRAUD_CHECK) {
    return
  }

  const { load: loadSignifyd, reset: resetSignifyd } = useSignifyd({
    trigger: 'manual',
  })

  watchEffect(async () => {
    switch (toValue(currentStep)) {
      case 'CHECKOUT_IN_PROGRESS':
        await loadSignifyd()
        break
      case 'CHECKOUT_ENDED':
        // Signifyd session ID should be reset once the payment is done.
        // Some user never reach the payment result page, but this + the short lifetime of the cookie should be enough.
        await resetSignifyd()
        break
      default:
        break
    }
  })
}
